import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons'
import type { AdvertisingPlatform } from '@entities/partner/model/types'
import { CopyButton } from '@shared/ui/copy-button/copy-button'
import type { FormProps, TableProps } from 'antd'
import { Button, Checkbox, Col, Dropdown, Form, Input, Popconfirm, Row, Space, Table, theme, Typography } from 'antd'
import { useMemo } from 'react'

const { Text } = Typography

type AdvPlatformFormFields = {
    name: string
}

export const AdvertisingPlatforms = () => {
    const onFinish: FormProps<AdvPlatformFormFields>['onFinish'] = async (values) => {
        console.log('onFinish', values)
    }

    const [form] = Form.useForm()

    const {
        token: { colorLink }
    } = theme.useToken()

    const columns: TableProps<AdvertisingPlatform>['columns'] = useMemo(
        () => [
            {
                title: 'Название интернет ресурса',
                dataIndex: 'name',
                key: 'name',
                render: (_, record) => (
                    <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                        <Text>{record.name}</Text>
                        <CopyButton textToCopy={record.name} />
                    </Space>
                )
            },
            {
                title: 'Виден партнеру',
                dataIndex: 'visible',
                key: 'visible',
                align: 'center',
                render: (_, record) => <Checkbox checked={record.visible} onChange={(val) => console.log(val)} />
            },
            {
                title: '',
                key: 'action',
                render: (_, record) => (
                    <Dropdown
                        trigger={['click']}
                        menu={{
                            items: [
                                {
                                    key: '1',
                                    label: (
                                        <Space style={{ color: colorLink, width: '100%' }}>
                                            <EditOutlined /> Редактировать
                                        </Space>
                                    )
                                },
                                {
                                    key: '3',
                                    danger: true,
                                    label: (
                                        <Popconfirm
                                            title="Удалить площадку"
                                            description="Вы уверены что хотите удалить площадку?"
                                            // onConfirm={() => deletePost(record.id)}
                                            okText="Удалить"
                                            cancelText="Отмена"
                                        >
                                            <Space style={{ width: '100%' }}>
                                                <DeleteOutlined /> Удалить
                                            </Space>
                                        </Popconfirm>
                                    )
                                }
                            ]
                        }}
                    >
                        <MoreOutlined />
                    </Dropdown>
                )
            }
        ],
        [colorLink]
    )

    return (
        <>
            <Form
                form={form}
                name="add-adv-platform"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={onFinish}
            >
                <Row gutter={16} align={'bottom'}>
                    <Col span={4}>
                        <Form.Item
                            label="Введите название канала  или интернет ресурса"
                            name="name"
                            required={false}
                            rules={[{ required: true, message: 'Обязательное поле' }]}
                        >
                            <Input placeholder="@nikname / https://telegaplan.me" />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Button type="primary" htmlType="submit" style={{ marginBottom: 24 }}>
                            Сохранить
                        </Button>
                    </Col>
                </Row>
            </Form>
            <Row>
                <Col span={7}>
                    <Table<AdvertisingPlatform>
                        columns={columns}
                        dataSource={[{ name: 'test', visible: false }]}
                        pagination={false}
                    />
                </Col>
            </Row>
        </>
    )
}
